/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Settings_Group_AccountInputs */

const cs_nav_settings_group_account = /** @type {(inputs: Nav_Settings_Group_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Účet`)
};

const en_nav_settings_group_account = /** @type {(inputs: Nav_Settings_Group_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Nav_Settings_Group_AccountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_settings_group_account = /** @type {((inputs?: Nav_Settings_Group_AccountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Settings_Group_AccountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_settings_group_account(inputs)
	return cs_nav_settings_group_account(inputs)
});